import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"

import axios from "./axios";
import qs from 'qs';
import './assets/global.css'
import '../global.css'
import { hasPermission, hasAllPermissions } from '@/utils/permission'
import errorHandler from '@/utils/errorHandler'
Vue.config.productionTip = false

// 全局错误处理器 - 防止错误显示在用户界面上
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue全局错误:', err)
  console.error('错误信息:', info)
  console.error('组件实例:', vm)

  // 可以在这里添加错误上报逻辑
  // 例如发送到错误监控服务

  // 阻止Vue默认的错误处理行为（防止错误显示在页面上）
  return false
}

// 捕获Promise中未处理的错误
window.addEventListener('unhandledrejection', function(event) {
  const reason = event && event.reason
  const msg = reason && reason.message ? String(reason.message) : ''
  const isRouterNavError = msg.includes('Navigation cancelled') || msg.includes('Avoided redundant navigation')
  if (isRouterNavError) {
    // 忽略 vue-router 导航取消/重复导航错误
    event.preventDefault()
    return
  }
  console.error('未处理的Promise错误:', reason)
  // 阻止错误显示在控制台
  event.preventDefault()
})

Vue.use(Element);

Vue.prototype.$axios = axios;// 全局使用
Vue.prototype.$qs = qs;

// 注册全局错误处理工具
Vue.prototype.$errorHandler = errorHandler;

// 全局权限检查方法
/**
 * 检查是否有指定权限
 * @param {String|Array} permission 权限标识，可以是字符串或数组（多个权限任一即可）
 * @returns {Boolean} 是否有权限
 * 
 * 使用示例：
 * this.$hasPermission('/outpatientDoctor/medicalRecord/finishReception')
 * this.$hasPermission(['/permission1', '/permission2']) // 任一权限即可
 */
Vue.prototype.$hasPermission = function(permission) {
  return hasPermission(permission, this.$store)
}

/**
 * 检查是否有所有指定权限（需要同时拥有）
 * @param {Array} permissions 权限标识数组
 * @returns {Boolean} 是否拥有所有权限
 * 
 * 使用示例：
 * this.$hasAllPermissions(['/permission1', '/permission2'])
 */
Vue.prototype.$hasAllPermissions = function(permissions) {
  return hasAllPermissions(permissions, this.$store)
}

// require("./mock");


// 计算年龄（返回年、月、日）
Vue.prototype.$calculateAge = function(birthDateStr) {
  const birthDate = new Date(birthDateStr);
  const today = new Date();

  // 计算年份差
  let years = today.getFullYear() - birthDate.getFullYear();

  // 计算月份差
  let months = today.getMonth() - birthDate.getMonth();

  // 计算天数差
  let days = today.getDate() - birthDate.getDate();

  // 处理负天数（向月借位）
  if (days < 0) {
    // 获取上个月的天数（当前月份0号即上个月最后一天）
    const daysInPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    days += daysInPrevMonth;
    months--;
  }

  // 处理负月份（向年借位）
  if (months < 0) {
    months += 12;
    years--;
  }

  return {
    years: years,
    months: months,
    days: days
  };
};
// 根据年龄计算出生日期（可接收年、月、日中的任意参数）
Vue.prototype.$calculateBirthDate = function(years = 0, months = 0, days = 0) {
  if (!years && !months && !days) {
    return ''
  }
  const today = new Date();

  // 创建结果日期对象（初始为今天）
  let resultDate = new Date(today);

  // 处理年份（如果有传入）
  if (years > 0) {
    resultDate.setFullYear(resultDate.getFullYear() - years);
  }

  // 处理月份（如果有传入）
  if (months > 0) {
    // 先减去整月
    resultDate.setMonth(resultDate.getMonth() - months);

    // 移除这个额外的年份检查，因为setMonth已经能正确处理跨年情况
    // 这个检查可能导致在某些情况下多减一年
    // if (resultDate.getMonth() > today.getMonth()) {
    //   resultDate.setFullYear(resultDate.getFullYear() - 1);
    // }
  }

  // 处理天数（如果有传入）
  if (days > 0) {
    // 减去天数（Date对象会自动处理跨月/跨年）
    resultDate.setDate(resultDate.getDate() - days);
  }

  // 格式化为YYYY-MM-DD
  const year = resultDate.getFullYear();
  const month = String(resultDate.getMonth() + 1).padStart(2, '0');
  const day = String(resultDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
Vue.prototype.$getCurrentDate = function () {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')